import React, { useState } from "react";
import { useAuth } from "../../../../utils/useAuth";
import { updateProfileApi } from "../../../../api/website/profile/profileAPI";

const Profile = () => {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({
    fullName: user?.fullName || "",
    phoneNumber: user?.phoneNumber || "",
    email: user?.email || "",
  });
  const [saving, setSaving] = useState(false);

  const dirty =
    form.fullName !== user?.fullName || form.phoneNumber !== user?.phoneNumber;

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSave = async () => {
    if (!dirty) return;
    setSaving(true);
    await updateProfileApi(
      user.id,
      { fullName: form.fullName, phoneNumber: form.phoneNumber },
      (updated) => {
        // reflect in auth context if available
        setUser && setUser((prev) => ({ ...prev, ...updated }));
      },
    );
    setSaving(false);
  };

  const initials = (form.fullName || "U")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className="space-y-6">
      {/* header card */}
      <div className="flex items-center gap-4 p-4 rounded-xl bg-gradient-to-r from-[#e7f3fe] to-[#f5faff] border">
        <div className="w-16 h-16 rounded-full bg-blue-600 text-white flex items-center justify-center text-xl font-bold shrink-0">
          {initials}
        </div>
        <div className="min-w-0">
          <p className="text-lg font-semibold text-gray-800 truncate">
            {form.fullName || "Your name"}
          </p>
          <p className="text-sm text-gray-500 truncate">{form.email}</p>
        </div>
      </div>

      {/* form */}
      <div>
        <p className="font-bold uppercase text-sm text-gray-600 mb-3">
          Profile Information
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="text-xs text-gray-500">Full Name</label>
            <input
              name="fullName"
              type="text"
              value={form.fullName}
              onChange={handleChange}
              className="w-full border p-2.5 mt-1 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500">Phone Number</label>
            <input
              name="phoneNumber"
              type="text"
              value={form.phoneNumber}
              onChange={handleChange}
              className="w-full border p-2.5 mt-1 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>
          <div className="md:col-span-2">
            <label className="text-xs text-gray-500">Email Address</label>
            <input
              name="email"
              type="text"
              value={form.email}
              readOnly
              className="w-full border p-2.5 mt-1 rounded-lg bg-gray-50 text-gray-500 cursor-not-allowed focus:outline-none"
            />
            <p className="text-[11px] text-gray-400 mt-1">
              Email cannot be changed.
            </p>
          </div>
        </div>

        <div className="flex justify-end mt-5">
          <button
            onClick={handleSave}
            disabled={!dirty || saving}
            className="px-6 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
